export function setActiveBlock(id) {
    return { type: 'SET_ACTIVE_BLOCK', payload: id };
}

export function updateSettings(settings) {
    return { type: 'BLOK_EDITOR_UPDATE_SETTINGS', payload: settings };
}

export function updateHistory(item) {
    return { type: 'BLOK_EDITOR_UPDATE_HISTORY', payload: item };
}

export function updateStateLook(look) {
    return { type: 'BLOK_EDITOR_UPDATE_STATE_LOOK', payload: look };
}

export function setState(index) {
    return { type: 'BLOK_EDITOR_SET_STATE', payload: index };
}

export function setOpenDropdownItem(item) {
    return { type: 'SET_OPEN_BLOK_EDITOR_DROPDOWN_ITEM', payload: item };
}
